var _module = require('../components/module.js');
var moment  = require('moment');

_module.filter('timeago', function () {
    return function (date) {
        var TODAY = moment().startOf('day');
        var now = moment(new Date());
        date = moment(date);

        if(date.isSame(TODAY, 'd') || now.diff(date, 'hours') < 3) {
            return moment.duration(now - date).humanize() + ' ago';
        } else {
            return date.format('MMM DD, YYYY - h:mm A');
        }
    };
});
